export const SHIPMENT_URLS = {
  NOUVEAU: '/dossiers/nouveau',
  A_TRAITER: '/dossiers?shipment_stage=A+TRAITER&sort=pickup_date,shipment_number',
  EN_COURS: '/dossiers?shipment_stage=EN+COURS&sort=pickup_date,shipment_number',
  LIVRE: '/dossiers?shipment_stage=LIVRÉ&sort=-delivery_date',
  PRE_FAC: '/pre-fac?invoicing_status=PRÉ-FAC&sort=pickup_date,shipment_number',
  TOUS: '/dossiers',
  SUPPRIMES: '/supprimes?shipment_is_active=false',
};

export const CLIENT_URLS = {
  NOUVEAU: '/clients/nouveau',
  TOUS: '/clients',
};

export const CARRIER_URLS = {
  NOUVEAU: '/transporteurs/nouveau',
  TOUS: '/transporteurs',
};

export const INVOICE_URLS = {
  TOUTES: '/factures',
  AVOIRS: '/factures?document_type=credit',
};
